"use strict";
/**
 * ZONE DI ALLENAMENTO — soglie di dominio universali (fonte unica @leopart/calc).
 *
 * Standard scientifici (Mann/González-Badillo per la VBT; zone %VMA classiche
 * per l'endurance; 30-15 IFT per l'HIIT): NON sono config per-team, sono
 * costanti di letteratura. Vivevano hardcoded in
 * apps/backend/src/profiling/services/profiling-formulas.ts — qui diventano
 * fonte unica, così un domani frontend/mobile che mostrano le stesse zone non
 * ne reinventano i confini.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIIT_ZONES = exports.VMA_TRAINING_ZONES = exports.VBT_VELOCITY_ZONES = void 0;
/** Zone velocità VBT (Mann/González-Badillo), qualitativamente uguali Lower/Upper. */
exports.VBT_VELOCITY_ZONES = [
    { zone: 'forza_max', range: [0.3, 0.5], label: 'Forza massimale' },
    { zone: 'forza_velocita', range: [0.5, 0.75], label: 'Forza-velocità' },
    { zone: 'potenza', range: [0.75, 1.0], label: 'Potenza' },
    { zone: 'velocita', range: [1.0, 99], label: 'Velocità' },
];
/** Zone allenamento %VMA (endurance). I range di velocità = VMA × pct (nel calcolo). */
exports.VMA_TRAINING_ZONES = [
    { zone: 'recupero', pct: [0.5, 0.65] },
    { zone: 'fondamentale', pct: [0.65, 0.8] },
    { zone: 'soglia', pct: [0.8, 0.95] },
    { zone: 'vma', pct: [0.95, 1.05] },
    { zone: 'sopra_vma', pct: [1.05, 1.2] },
];
/** Zone HIIT del 30-15 IFT. I range di velocità = VIFT × pct (nel calcolo). */
exports.HIIT_ZONES = [
    { zone: 'aerobico_intenso', pct: [0.85, 0.95] },
    { zone: 'vift', pct: [0.95, 1.05] },
    { zone: 'sovramassimale', pct: [1.05, 1.2] },
];
